export default __webpack_public_path__ + "static/property-img-2_1600-529fe7599a75b2c498fe2975483985ab.jpg";